//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BMap from 'BMap'
// import { setTimeout } from 'timers';
// import MP from '../../../map.js'
export default {
  mounted () {
    this.baiduMap()
  },
  methods: {
    baiduMap () {
      var map = new BMap.Map('map')
      var point = new BMap.Point(116.464412, 39.991185)
      map.centerAndZoom(point, 17)
      map.addControl(new BMap.MapTypeControl())
      map.setCurrentCity('北京华影云商科技有限公司')
      map.enableScrollWheelZoom(true)
      map.enableDoubleClickZoom(true)
      var marker = new BMap.Marker(point)
      map.addOverlay(marker)
      // setTimeout(() => {
      //   var map = new BMap.Map('amap')
      //   console.log(map)
      // }, 0.5)
      // document.ready = () => {
      // map = new BMap.Map('amap')
      // console.log(map)
      // }

      // map.centerAndZoom(new BMap.Point(116.464412, 39.991185), 17)
      // map.addControl(new BMap.MapTypeControl())
      // map.setCurrentCity('北京华影云商科技有限公司')
      // map.enableScrollWheelZoom(true)

      // var marker = new BMap.Marker(new BMap.Point(116.464398, 39.991179))
      var label = new BMap.Label('北京华影云商科技有限公司')

      label.setStyle({
        borderColor: '#808080',
        color: '#333',
        cursor: 'pointer'
      })
      marker.setLabel(label)
      map.addOverlay(marker)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/aboutOur/contact.vue